<template>
  <div class="login-container">
    <div class="top-bar flex">
      <topbar class="flex1"></topbar>
    </div>
    <router-view />
  </div>
</template>
<script>
import topbar from "../topbar/index";
export default {
  components:{
    topbar
  }
};
</script>
